import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import AuthContext from "src/store/auth-context";

const ProtectedRoute = props => {
  const authCtx = useContext(AuthContext);

  return authCtx.isLoggedIn ? (
    <Route {...props} />
  ) : (
    <Redirect
      to={{
        pathname: '/login',
        state: { from: props.location },
      }}
    />
  );
};

export default ProtectedRoute;
